var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.357,
    height: 19.374,
    viewBox: "0 0 23.357 19.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye_crossed",
    "data-name": "Eye crossed",
    transform: "translate(1 1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10106",
    "data-name": "Group 10106",
    transform: "translate(-1484.73 714.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M1504.93-707.615a4.17,4.17,0,0,1,0,5.769c-2.21,2.137-5.653,4.678-9.52,4.678s-7.31-2.541-9.52-4.678a4.17,4.17,0,0,1,0-5.769c2.21-2.136,5.653-4.678,9.52-4.678S1502.719-709.752,1504.93-707.615Z",
    transform: "translate(0 -1.102)",
    fill: "none",
    stroke: "#08070d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4911",
    "data-name": "Ellipse 4911",
    cx: 3.324,
    cy: 3.324,
    r: 3.324,
    transform: "translate(1492.086 -709.157)",
    fill: "none",
    stroke: "#08070d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15161",
    "data-name": "Path 15161",
    d: "M880.57,365.611l16.545-16.545",
    transform: "translate(-878.138 -349.066)",
    fill: "rgba(0,0,0,0)",
    stroke: "#08070d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/EyeCrossed.e1e98855c4117d269e84b72a706c01f9.svg";
export { ForwardRef as ReactComponent };